(() => {
  /**
   * @description Correction of rounding of decimals
   *
   * @param {String}  type  Correction type
   * @param {number}  valueParam Number.
   * @param {number}  expParam   pow.
   * @returns {number} Corrected value.
   */
  const decimalAdjust = (type, valueParam, expParam) => {
    let value = Number(valueParam);
    const exp = Number(expParam);
    if (typeof expParam === 'undefined' || exp === 0) {
      return Math[type](value);
    }
    if (Number.isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    let valueArr = value.toString().split('e');
    value = Math[type](+`${valueArr[0]}e${valueArr[1] ? +valueArr[1] - exp : -exp}`);
    valueArr = value.toString().split('e');
    return +`${valueArr[0]}e${valueArr[1] ? +valueArr[1] + exp : exp}`;
  };

  /**
   * Math trunc polyfill
   */
  const trunc = (num) => (num > 0 ? Math.floor(num) : Math.ceil(num));
  if (!Math.trunc) {
    Math.trunc = trunc;
  }

  if (!Math.round10) {
    Math.round10 = (value, exp) => decimalAdjust('round', value, exp);
  }

  if (!Math.floor10) {
    Math.floor10 = (value, exp) => decimalAdjust('floor', value, exp);
  }

  if (!Math.ceil10) {
    Math.ceil10 = (value, exp) => decimalAdjust('ceil', value, exp);
  }

  if (!RegExp.escape) {
    RegExp.escape = function escapeRegExp(text) {
      return text && text.replace ? text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') : text;
    };
  }

  /**
   * Custom Event constructor polyfill
   */
  // eslint-disable-next-line func-names
  function CustomEventPolyfill(event, params) {
    const evt = document.createEvent('CustomEvent');
    const eventParams = params || { bubbles: false, cancelable: false, detail: undefined };
    evt.initCustomEvent(event, eventParams.bubbles, eventParams.cancelable, eventParams.detail);
    return evt;
  }
  if (typeof window.CustomEvent !== 'function') {
    CustomEventPolyfill.prototype = window.Event.prototype;
    window.CustomEvent = CustomEventPolyfill;
  }

  Number.isInteger = Number.isInteger || ((value) => typeof value === 'number' && Number.isFinite(value) && Math.floor(value) === value);
  Number.isFinite = Number.isFinite || ((value) => typeof value === 'number' && Number.isFinite(value));

  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
      value: function assign(target, ...sources) {
        if (target == null) {
          // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }
        const to = Object(target);
        sources.forEach((nextSource) => {
          if (nextSource != null) {
            Object.keys(nextSource).forEach((nextKey) => {
              to[nextKey] = nextSource[nextKey];
            });
          }
        });
        return to;
      },
      writable: true,
      configurable: true,
    });
  }

  // For IE
  if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function remove() {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }
})();
